import { apiFetch } from "../../../api/core";
import { useSmartList } from "../../../hooks/useSmartList";
import { getRandomTagColor, Tag, TagSchema } from "../types";
import { useTagsMerge } from "./useTagsMerge";

export const useTagsList = (apiPath: string) => {
  const tagsApiPath = `${apiPath}/tag`;

  const data = useSmartList<Tag>(`${tagsApiPath}`, {
    newRecordDefault: { color: getRandomTagColor() },
    getRecordApiPath: r => `${tagsApiPath}/${r._id}`,
    editRecordSettings: {
      dontResetOnSave: true,
    },
    schema: TagSchema,
    noView: true,
    textFilterApi: {
      paramName: "search",
    },
    skipTextFilter: true,
  });

  const findTag = (id: string) => apiFetch<Tag>(`${tagsApiPath}/${id}`);

  const merge = useTagsMerge();

  return {
    ...data,
    findTag,
    merge,
  };
};

export type TagsListData = ReturnType<typeof useTagsList>;
